import { FlowGraphWithOnDoneExecutionBlock } from "../../../flowGraphWithOnDoneExecutionBlock.js";
import { RichTypeAny } from "../../../flowGraphRichTypes.js";
/**
 * @experimental
 * Block that stops a running animation
 */
export class FlowGraphPauseAnimationBlock extends FlowGraphWithOnDoneExecutionBlock {
    constructor() {
        super();
        this.animationToPause = this._registerDataInput("animationToPause", RichTypeAny);
    }
    _execute(context) {
        const animationToPauseValue = this.animationToPause.getValue(context);
        animationToPauseValue.pause();
        this.onDone._activateSignal(context);
    }
}
//# sourceMappingURL=flowGraphPauseAnimationBlock.js.map